

















import { Vue, Component } from 'vue-property-decorator'
import FilterForm from '@/components/LayerFilterForms/FilterForm.vue'
import { storage, search } from '@/store/modules'
import { EntityFilterCriteria } from '@/store/search'
import { EntityType } from '@/orrm/model/entity-type'

@Component({
  components: { FilterForm }
})
export default class EntityFilterForm extends Vue {
  get criterias (): EntityFilterCriteria {
    return search.entityCriterias
  }

  get entityTypes (): EntityType[] {
    return storage.orderedEntityTypes
  }

  get loadingEntityTypes (): boolean {
    return storage.loadingEntityTypes
  }
}
